<template>
  <div class="tags-list-container">
    <transition-group name="tag-fade" tag="div" class="tags-wrapper">
      <!-- 普通标签项 -->
      <div 
        v-for="(item, index) in displayList" 
        :key="'tag-' + String(item[keyValue])" 
        class="tag-item"
      >
        <span class="tag-text">{{ item[labelValue] }}</span>
        <img v-show="showClear" src="@/assets/images/ico_close_small@2x.png" @click.stop="handleRemove(item)" class="tag-close">
      </div>

      <!-- 清除全部按钮 (样式与 Tag 保持一致) -->
      <div 
        v-if="displayList.length > 0 && showAllClear" 
        key="clear-all-btn"
        class="tag-item clear-all-tag" 
        @click="handleClearAll"
      >
        <span class="tag-text">{{ allClaearText }}</span>
        <img src="@/assets/images/ico_delete@2x.png" class="tag-close">
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'TagsList',
  props: {
    // 绑定的值，数组类型
    value: {
      type: Array,
      default: () => []
    },
    // 显示字段名
    labelValue: {
      type: String,
      default: 'name'
    },
    // 唯一标识字段名 (用于 key)
    keyValue: {
      type: String,
      default: 'id'
    },
    // 展示清除按钮
    showClear: {
      type: Boolean,
      default: true
    },
    // 显示全部清除按钮
    showAllClear: {
      type: Boolean,
      default: true
    },
    // 占位符
    allClaearText: {
      type: String,
      default: '重置所有条件'
    }
  },
  computed: {
    displayList() {
      return this.value || [];
    }
  },
  methods: {
    // 删除单个标签
    handleRemove(item) {
      const newVal = this.displayList.filter(v => {
        if (this.keyValue && v[this.keyValue] !== undefined && item[this.keyValue] !== undefined) {
          return v[this.keyValue] !== item[this.keyValue];
        }
        return v !== item;
      });
      this.emitChange(newVal);
    },

    // 清除所有标签
    handleClearAll() {
      this.emitChange([]);
    },

    // 触发更新
    emitChange(val) {
      this.$emit('input', val);
      this.$emit('change', val);
    }
  }
};
</script>

<style lang="scss" scoped>
.tags-list-container {
  width: 100%;
  
  .tags-wrapper {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    // 关键：使用 gap 控制间距，兼容性良好的现代浏览器都会生效
    gap: 8px; 
  }

  .tag-item {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    background-color: #f5f5f5; // 浅灰背景
    border-radius: 4px;
    font-size: 14px;
    color: #333333;
    // border: 1px solid #e4e7ed; // 增加边框增强质感
    cursor: default;
    transition: all 0.2s;
    height: 28px; // 固定高度确保对齐
    box-sizing: border-box;

    // 悬停效果
    // &:hover {
    //   background-color: #ecf5ff; // 悬停变浅蓝或浅红，这里用浅蓝示意，也可改为 #fff0f1
    //   border-color: #c6e2ff;
    //   color: #409eff;

    //   .tag-close {
    //     color: #409eff;
    //   }
    // }

    .tag-text {
      margin-right: 4px;
      max-width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 1;
    }

    .tag-close {
      cursor: pointer;
    //   font-size: 14px;
    //   line-height: 1;
    //   color: #909399;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 14px;
      height: 14px;
      
    //   &:hover {
    //     color: #ff5967; // 关闭按钮悬停变红
    //     background-color: rgba(255, 255, 255, 0.8);
    //     border-radius: 50%;
    //   }
    }

    // 特殊样式：清除全部按钮
    &.clear-all-tag {
    //   color: #ff5967; // 文字红色
    //   border-color: #ffd0d5;
    //   background-color: #fff0f1;
      
      &:hover {
        // background-color: #ff5967;
        // border-color: #ff5967;
        // color: #ffffff;
        
        // .tag-close {
        //   color: #ffffff;
        //   background-color: rgba(255, 255, 255, 0.2);
        // }
        cursor: pointer;
      }
    }
  }
}

/* 标签消失/出现动画 */
.tag-fade-enter-active, .tag-fade-leave-active {
  transition: all 0.3s ease;
}
.tag-fade-enter, .tag-fade-leave-to {
  opacity: 0;
  transform: scale(0.8);
}
</style>